module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Bottenwil-8c19f249e20fe1a1a7218e7179ecdc4b.svg";